import React, { FC, useCallback, useContext, useMemo, useState } from 'react';

// components
import AampeTooltip from '../../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';
// icons
import ICONS from '../../../../constants/icons';

// context
import { EditorContext } from '../../../../context/EditorContext';

// helper
import { getWhatsappTemplate } from '../../../../helpers/formulaHelpers';

const WhatsAppTemplateMain: FC<React.PropsWithChildren<unknown>> = () => {
    const [copySuccess, setCopySuccess] = useState<boolean>(false);

    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    const templateString = useMemo<string>(
        () => getWhatsappTemplate(formula?.structure ?? []),
        [formula],
    );

    const handleCopy = useCallback(async () => {
        try {
            await navigator.clipboard.writeText(templateString);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (e) {
            console.warn('Copy failed', e);
        }
    }, [templateString]);

    return (
        <Container>
            <Body>
                <Text>Whatsapp Template</Text>
                <AampeTooltip title="Click to copy the template">
                    <div onClick={handleCopy}>
                        {copySuccess ? (
                            <IconSuccess size={16} />
                        ) : (
                            <Icon size={16} />
                        )}
                    </div>
                </AampeTooltip>
            </Body>
            <Template>{templateString}</Template>
        </Container>
    );
};

const Container = styled.div(() => ({
    display: 'flex',
    marginTop: aampeTheme.spacing(2),
    flexDirection: 'column',
    gap: aampeTheme.spacing(2),
}));

const Text = styled.span(() => ({
    fontWeight: 'bold',
}));

const Body = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(1),
}));

const Template = styled.span(() => ({
    whiteSpace: 'pre-line',
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
    padding: aampeTheme.spacing(2),
    fontSize: 16,
}));

const Icon = styled(ICONS.copy)(() => ({ cursor: 'pointer' }));

const IconSuccess = styled(ICONS.check)(() => ({
    color: aampeTheme.colors.success500,
}));

export default WhatsAppTemplateMain;
